var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Alert, Button } from "@mui/material";
import { useAsyncAction } from "nate-react-api-helpers";
import { api } from "../../../../api/API";
import { useConfirm } from "../../../../misc/Confirm";
import { useSnackbar } from "../../../../misc/Snackbar";
import { useReloader } from "../hardware/ReloadContext";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function BaseBuildingBanner(props) { const confirm = useConfirm(); const snack = useSnackbar(); const reload = useReloader(); const unlink = useAsyncAction((input) => __awaiter(this, void 0, void 0, function* () { try {
    yield confirm.confirm("Unlink the base building project? Openings from that project stay in the shortcodes, but show a warning.");
}
catch (e) {
    return;
} try {
    snack.loading("Loading...");
    yield api.keying2.setBaseBuilding({ project: input.project, baseBuildingProject: null });
    reload.current();
    snack.success("Unlinked");
}
catch (e) {
    snack.error(e.toString());
} }), [confirm]); if (!props.value.baseBuildingProject)
    return null; return /*#__PURE__*/ _jsxs(Alert, { severity: "info", action: /*#__PURE__*/ _jsx(Button, { color: "inherit", size: "small", disabled: unlink.loading, onClick: () => unlink.callback({ project: props.value.project }), children: "Unlink" }), children: ["Linked to base building ", props.value.baseBuildingProjectName] }); }
